(() => {
  const selectedClass = "is-selected";
  const scopeFor = (node) => node.closest(".m-main-product, [data-view='product'], [data-view='featured-product']") || node.closest("[data-product-id]") || document;
  const money = (euros) => {
    const cents = Math.round(Number(euros) * 100);
    if (!Number.isFinite(cents)) return "";
    if (typeof window.formatMoney === "function") return window.formatMoney(cents, window.MinimogSettings?.money_format);
    return new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(cents / 100);
  };
  const reset = (scope) => {
    scope.querySelectorAll("[data-lfl-presentation-price-hidden]").forEach((node) => {
      node.hidden = node.dataset.lflPresentationPriceWasHidden === "true";
      node.removeAttribute("data-lfl-presentation-price-hidden");
      node.removeAttribute("data-lfl-presentation-price-was-hidden");
    });
    scope.querySelectorAll("[data-lfl-presentation-price-label]").forEach((node) => node.remove());
    scope.querySelectorAll("[data-lfl-presentation-blocked]").forEach((form) => {
      delete form.dataset.lflPresentationBlocked;
      form.querySelectorAll("[data-lfl-presentation-disabled]").forEach((control) => {
        control.disabled = false;
        control.removeAttribute("aria-disabled");
        control.removeAttribute("data-lfl-presentation-disabled");
      });
    });
    scope.querySelectorAll("[data-lfl-presentation-hidden]").forEach((node) => {
      node.hidden = false;
      node.removeAttribute("data-lfl-presentation-hidden");
    });
  };
  document.addEventListener("click", (event) => {
    const button = event.target.closest?.("[data-showroom-option]");
    if (!button) return;
    const scope = scopeFor(button);
    button.closest("[data-showroom-options]")?.querySelectorAll("[data-showroom-option]").forEach((item) => {
      item.classList.toggle(selectedClass, item === button);
      item.setAttribute("aria-pressed", item === button ? "true" : "false");
    });
    if (button.dataset.presentationStatus === "exact_price") {
      reset(scope);
      const formatted = money(button.dataset.presentationPrice);
      scope.querySelectorAll("[data-lfl-exact-price], [data-lfl-sticky-price]").forEach((node) => { node.textContent = formatted; });
      return;
    }
    if (button.dataset.presentationStatus !== "quote_only") return;
    const label = window.LFLPriceStrings?.variantOnDemand || "Tarif sur demande pour cette dimension";
    scope.querySelectorAll("[data-lfl-exact-price], [data-lfl-sticky-price], [data-lfl-price]").forEach((node) => { node.textContent = label; });
    scope.querySelectorAll(".m-price[data-sales-mode='ecommerce']").forEach((price) => {
      Array.from(price.children).forEach((node) => {
        if (node.hasAttribute("data-lfl-presentation-price-label")) return;
        node.dataset.lflPresentationPriceWasHidden = node.hidden ? "true" : "false";
        node.dataset.lflPresentationPriceHidden = "true";
        node.hidden = true;
      });
      if (!price.querySelector("[data-lfl-presentation-price-label]")) {
        const quote = document.createElement("span");
        quote.className = "m-price-item m-price-item--regular";
        quote.dataset.lflPresentationPriceLabel = "true";
        quote.textContent = label;
        price.appendChild(quote);
      }
    });
    scope.querySelectorAll("form[action*='/cart/add']").forEach((form) => {
      form.dataset.lflPresentationBlocked = "true";
      form.querySelectorAll("button[type='submit'], input[type='submit']").forEach((control) => {
        if (!control.disabled) control.setAttribute("data-lfl-presentation-disabled", "true");
        control.disabled = true;
        control.setAttribute("aria-disabled", "true");
      });
      form.querySelectorAll("[name='id']").forEach((input) => {
        if (!input.disabled) input.setAttribute("data-lfl-presentation-disabled", "true");
        input.disabled = true;
      });
    });
    scope.querySelectorAll(".shopify-payment-button, .m-product-dynamic-checkout").forEach((node) => {
      if (!node.hidden) node.setAttribute("data-lfl-presentation-hidden", "true");
      node.hidden = true;
    });
  });
  document.addEventListener("change", (event) => {
    if (!event.target.closest?.("variant-picker, [data-variant-picker], .m-product-option")) return;
    const scope = scopeFor(event.target);
    scope.querySelectorAll("[data-showroom-option]").forEach((button) => {
      button.classList.remove(selectedClass);
      button.setAttribute("aria-pressed", "false");
    });
    reset(scope);
  });
})();
